module.exports = __webpack_public_path__ + "media/images/sp/page_common/icon/icon_plan_included_03-8225f4793e3f0e151e06fa6410f3637d.png";